import { fromJS } from 'immutable';
import { CHECK_PUSH, SET_PUSH_STATUS, TURN_OFF_PUSH, TURN_ON_PUSH } from './constants';

export const checkPush = () => ({ type: CHECK_PUSH });
export const turnOnPush = () => ({ type: TURN_ON_PUSH });
export const turnOffPush = () => ({ type: TURN_OFF_PUSH });

/**
 * @param {string} status as pushStatus says, or 'server-off' when the server isn't set up to send pushes
 * @param {string|null} error why turning notifications on or off just failed
 */
export const setPushStatus = (status, error = null) => ({
  type: SET_PUSH_STATUS,
  payload: fromJS({ status, error }),
});
